var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BenefitCardMW, BenefitCardFullWidthDTW, BenefitCardHalfWidthDTW, } from '../../../shared/rewards-hub';
import { getHostURL, getImageURL } from '../../../../utils/GeneralUtil';
import { analyticsStash } from '../../../../utils/analytics';
import { rhAnalytics } from '../../../../constants/RewardsHub';
var constants = {
    title: "Business Tools",
    subtitle: "Take advantage of the powerful online and in-store business tools listed below:",
    iconUrl: getImageURL("WelcomeCard/active_BusinessTools.svg"),
    links: {
        Quotes: {
            label: 'Quotes',
            path: getHostURL('c/create-a-quote'),
            analytics: rhAnalytics.quotes,
        },
        VolumePricing: {
            label: 'Volume Pricing',
            path: getHostURL('a/pricing-benefits'),
            analytics: rhAnalytics.volumePricing,
        },
        Text2Confirm: {
            label: 'Text2Confirm',
            path: getHostURL('c/authorize-cards-text2confirm'),
            analytics: rhAnalytics.text2Confirm,
        },
        PurchaseTracking: {
            label: 'Purchase Tracking',
            path: getHostURL('myaccount/purchase-history'),
            analytics: rhAnalytics.purchaseTracking,
        },
        Path2Pro: {
            label: 'Path to Pro Network',
            path: getHostURL('path-to-pro-network'),
            analytics: rhAnalytics.path2Pro,
        },
        ProReferral: {
            label: 'Pro Referral',
            path: 'https://www.proreferral.com/pro-homepage?source=B2B',
            analytics: rhAnalytics.proReferral,
        },
    },
};
var BusinessToolsLinks = function (_a) {
    var isMobile = _a.isMobile;
    var businessToolsLinksClass = 'business-tools-links sui-flex sui-pt-2 sui-text-start sui-text-base sui-gap-6';
    if (isMobile) {
        businessToolsLinksClass =
            'business-tools-links sui-flex sui-flex-col sui-pt-2 sui-text-start sui-text-base sui-gap-3';
    }
    return (React.createElement("div", { className: businessToolsLinksClass },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-y-3" },
            React.createElement("a", { href: constants.links.Path2Pro.path, className: "sui-underline", onClick: function () {
                    analyticsStash(constants.links.Path2Pro.analytics);
                } }, constants.links.Path2Pro.label),
            React.createElement("a", { href: constants.links.PurchaseTracking.path, className: "sui-underline", onClick: function () {
                    analyticsStash(constants.links.PurchaseTracking.analytics);
                } }, constants.links.PurchaseTracking.label),
            React.createElement("a", { href: constants.links.ProReferral.path, className: "sui-underline", onClick: function () {
                    analyticsStash(constants.links.ProReferral.analytics);
                } }, constants.links.ProReferral.label)),
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-y-3" },
            React.createElement("a", { href: constants.links.Quotes.path, className: "sui-underline", onClick: function () {
                    analyticsStash(constants.links.Quotes.analytics);
                } }, constants.links.Quotes.label),
            React.createElement("a", { href: constants.links.Text2Confirm.path, className: "sui-underline", onClick: function () {
                    analyticsStash(constants.links.Text2Confirm.analytics);
                } }, constants.links.Text2Confirm.label),
            React.createElement("a", { href: constants.links.VolumePricing.path, className: "sui-underline", onClick: function () {
                    analyticsStash(constants.links.VolumePricing.analytics);
                } }, constants.links.VolumePricing.label))));
};
var BusinessToolsMW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle, content: React.createElement(BusinessToolsLinks, { isMobile: true }) });
    return React.createElement(BenefitCardMW, __assign({}, data));
};
var BusinessToolsFullWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle });
    return React.createElement(BenefitCardFullWidthDTW, __assign({}, data));
};
var BusinessToolsHalfWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle, content: !isLocked ? React.createElement(BusinessToolsLinks, null) : undefined });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var BusinessTools = function (props) {
    var isMobile = props.isMobile, isLocked = props.isLocked, fullWidth = props.fullWidth;
    var mockProp = props.mockProp; // TODO: Remove after demo
    var data = { isMobile: isMobile, isLocked: isLocked };
    if (isMobile)
        return React.createElement(BusinessToolsMW, __assign({}, data));
    // if (fullWidth) return <BusinessToolsHalfWidthDTW {...data} />;
    // return <BusinessToolsHalfWidthDTW {...data} />;
    // For Demo
    if (fullWidth)
        return React.createElement(BusinessToolsFullWidthDTW, __assign({}, data, { mockProp: mockProp }));
    return React.createElement(BusinessToolsHalfWidthDTW, __assign({}, data, { mockProp: mockProp }));
};
